export class ObjectImportResult {
  SuccessCount: number;
  ConflictImeis: number[];
  ConflictObjectNames: string[];

  constructor(data?: any) {
    if (data) {
      this.init(data);
    }
  }

  init(data: any): void {
    this.SuccessCount = data.successCount || 0;
    this.ConflictImeis = data.conflictImeis || [];
    this.ConflictObjectNames = data.conflictObjectNames || [];
  }

  static fromJS(data: any): ObjectImportResult {
    return new ObjectImportResult(data);
  }
}
